// extracted by mini-css-extract-plugin
export default {"compact":"box_compact__82SaO","box":"box_box__6rYWD"};